import { useEffect, useState } from "react";

const useIsMobile = (maxWidth: number): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = (): void => {
      setIsMobile(window.innerWidth <= maxWidth);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, [maxWidth]);

  return isMobile;
};

export default useIsMobile;
